export default __webpack_public_path__ + "static/media/dependency.30cd1b6d.png";